<mat-tab-group [selectedIndex]="activeIndex" (selectedIndexChange)="onTabChange($event)" [disablePagination]="false">
  <mat-tab *ngFor="let tab of tabs">
    <ng-template mat-tab-label>
      <img [src]="tab.icon" />
      <p>{{ tab.label }}</p>
    </ng-template>
    <ng-container *ngIf="templateFor(tab.id) as template" [ngTemplateOutlet]="template" />
  </mat-tab>
</mat-tab-group>
